/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Menu_Project_HistoryInputs */

const en_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project History`)
};

const fr_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique du projet`)
};

const de_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektgeschichte`)
};

const it_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronologia del progetto`)
};

const ru_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`История проекта`)
};

const es_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial del proyecto`)
};

const zh_cn2_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目历史`)
};

const ja_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの履歴`)
};

const hi_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना इतिहास`)
};

const pt_pt2_team_menu_project_history = /** @type {(inputs: Team_Menu_Project_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico do projeto`)
};

/**
* | output |
* | --- |
* | "Project History" |
*
* @param {Team_Menu_Project_HistoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_menu_project_history = /** @type {((inputs?: Team_Menu_Project_HistoryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Menu_Project_HistoryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_menu_project_history(inputs)
	if (locale === "de") return de_team_menu_project_history(inputs)
	if (locale === "it") return it_team_menu_project_history(inputs)
	if (locale === "ru") return ru_team_menu_project_history(inputs)
	if (locale === "es") return es_team_menu_project_history(inputs)
	if (locale === "zh-CN") return zh_cn2_team_menu_project_history(inputs)
	if (locale === "ja") return ja_team_menu_project_history(inputs)
	if (locale === "hi") return hi_team_menu_project_history(inputs)
	if (locale === "pt-PT") return pt_pt2_team_menu_project_history(inputs)
	return en_team_menu_project_history(inputs)
});